'use client';
export { default } from './components/partners';
